// extracted by mini-css-extract-plugin
export default {"actions":"styles_actions__VzrlX","title":"styles_title__sbTGL","header":"styles_header__dc4Yt","closeButton":"styles_closeButton__xqkE4"};